import React, { Component } from 'react';
import classNames from 'classnames';
import '../../assets/scss/core/Icon.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faFingerprint,faArrowRight, faArrowLeft,faSpinner,faUndo,faCheck,faStar,
  faClone,faTimes,faDownload,faThumbsUp,faEuroSign,faGlobe, faHome, faBolt,
  faLock, faTv, faToggleOn, faThermometerHalf, faMicrochip, faChevronUp,
  faChevronRight, faInfo, faLightbulb, faCog, faForward, faShoppingCart, faCloud
} from '@fortawesome/free-solid-svg-icons'
import { faCheckCircle,faLightbulb as faLightbulbR, faSquare as faSquareR, faCheckSquare as faCheckSquareR } from '@fortawesome/free-regular-svg-icons';
import { faAmazon } from '@fortawesome/free-brands-svg-icons';
class Icon extends Component {
  state = {
    style: {}
  }
  linearGradient = () =>{
    return <svg aria-hidden='true' focusable='false' style={{width:0,height:0,position:'absolute'}}>
      <linearGradient id='gradient' x2='1' y2='1'>
        <stop offset='0%' stopColor='#368cb5'/>
        <stop offset='100%' stopColor='#82a9c9'/>
      </linearGradient>
    </svg>
  }
  loader = ()=>{
    return <svg style={this.state.style} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 740.01608 848.1993375000001' version='1.1' x='0px' y='0px'><g transform='translate(-84.421939,-242.59935)'><path  d='m 549.765,242.5994 a 89.244933,89.244933 0 0 0 -89.335,89.214 89.244933,89.244933 0 0 0 89.335,89.3356 89.244933,89.244933 0 0 0 89.215,-89.3356 89.244933,89.244933 0 0 0 -89.215,-89.214 z m -229.458,12.9704 a 69.695452,69.695452 0 0 0 -69.698,69.6984 69.695452,69.695452 0 0 0 69.698,69.698 69.695452,69.695452 0 0 0 69.697,-69.698 69.695452,69.695452 0 0 0 -69.697,-69.6984 z M 164.909,401.8756 a 55.235041,55.235041 0 0 0 -55.153,55.2741 55.235041,55.235041 0 0 0 55.153,55.2735 55.235041,55.235041 0 0 0 55.274,-55.2735 55.235041,55.235041 0 0 0 -55.274,-55.2741 z m 551.284,15.0308 A 108.23586,108.23586 0 0 0 607.947,525.1509 108.23586,108.23586 0 0 0 716.193,633.3956 108.23586,108.23586 0 0 0 824.438,525.1509 108.23586,108.23586 0 0 0 716.193,416.9064 Z M 127.94,578.3639 a 43.443291,43.443291 0 0 0 -43.518,43.516 43.443291,43.443291 0 0 0 43.518,43.3948 43.443291,43.443291 0 0 0 43.394,-43.3948 43.443291,43.443291 0 0 0 -43.394,-43.516 z m 52.849,161.5793 a 39.967828,39.967828 0 0 0 -39.88,39.8797 39.967828,39.967828 0 0 0 39.88,40.0008 39.967828,39.967828 0 0 0 40,-40.0008 39.967828,39.967828 0 0 0 -40,-39.8797 z m 123.639,107.8809 a 31.217109,31.217109 0 0 0 -31.275,31.273 31.217109,31.217109 0 0 0 31.275,31.1525 31.217109,31.217109 0 0 0 31.151,-31.1525 31.217109,31.217109 0 0 0 -31.151,-31.273 z m 124.608,32.4857 a 20.418347,20.418347 0 0 0 -20.364,20.4847 20.418347,20.418347 0 0 0 20.364,20.3642 20.418347,20.418347 0 0 0 20.485,-20.3642 20.418347,20.418347 0 0 0 -20.485,-20.4847 z' fill='#000000'/></g></svg>
  }
  package = ()=>{
    return <svg style={this.state.style} version='1.1' xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 512 512' xmlSpace='preserve'> <g><g><path d='M256,339.993c-5.52,0-10,4.48-10,10s4.48,10,10,10c5.52,0,10-4.48,10-10C266,344.473,261.52,339.993,256,339.993z'/></g></g><g><g><path d='M148.115,112.274c-2.243-5.047-8.156-7.318-13.199-5.077l-42.981,19.102c-5.047,2.243-7.32,8.153-5.077,13.2 c1.655,3.727,5.311,5.941,9.143,5.941c1.357,0,2.736-0.278,4.056-0.864l42.981-19.102 C148.085,123.232,150.358,117.321,148.115,112.274z'/>	</g></g><g><g><path d='M420.067,126.3l-42.981-19.102c-5.046-2.24-10.957,0.03-13.199,5.077c-2.244,5.046,0.029,10.956,5.076,13.2l42.981,19.102 c1.32,0.586,2.699,0.864,4.056,0.864c3.831,0,7.487-2.215,9.144-5.941C427.387,134.453,425.114,128.543,420.067,126.3z'/></g></g><g><g><path d='M504.007,283.992l-60.002-80.002c-0.109-0.145-0.229-0.276-0.344-0.413c-0.068-0.081-0.132-0.164-0.203-0.243	c-0.287-0.322-0.59-0.624-0.909-0.901c-0.042-0.036-0.087-0.068-0.129-0.104c-0.303-0.254-0.618-0.485-0.944-0.698 c-0.07-0.046-0.138-0.092-0.21-0.136c-0.38-0.235-0.771-0.448-1.175-0.629c-0.009-0.004-0.016-0.01-0.025-0.013l-116.312-51.696 c14.279-16.262,22.248-37.127,22.248-59.17c0-25.564-10.93-50.012-29.988-67.074C296.975,5.866,271.373-2.284,245.77,0.555	c-19.189,2.123-37.615,10.781-51.885,24.38c-14.296,13.625-23.804,31.625-26.77,50.685c-4.223,27.13,3.592,53.643,21.117,73.544 l-116.3,51.689c-0.009,0.004-0.016,0.01-0.025,0.014c-0.404,0.18-0.794,0.393-1.174,0.628c-0.072,0.045-0.141,0.092-0.212,0.138 c-0.325,0.212-0.639,0.443-0.94,0.695c-0.043,0.036-0.09,0.069-0.133,0.106c-0.319,0.277-0.621,0.578-0.908,0.899 c-0.071,0.079-0.135,0.163-0.204,0.245c-0.115,0.137-0.234,0.268-0.343,0.412L7.992,283.992c-1.827,2.436-2.444,5.571-1.678,8.518    			c0.766,2.947,2.833,5.384,5.616,6.62l54.064,24.028v98.838c0,3.952,2.327,7.533,5.938,9.138l180.006,80.003	c0.017,0.007,0.034,0.012,0.051,0.019c0.264,0.116,0.534,0.217,0.809,0.31c0.049,0.017,0.097,0.038,0.147,0.054 c0.306,0.098,0.619,0.181,0.938,0.25c0.019,0.004,0.038,0.01,0.057,0.015c0.665,0.139,1.354,0.215,2.06,0.215 c0.706,0,1.395-0.075,2.06-0.215c0.019-0.004,0.038-0.01,0.057-0.015c0.318-0.069,0.631-0.152,0.938-0.25 c0.05-0.016,0.098-0.037,0.147-0.054c0.275-0.093,0.546-0.194,0.809-0.31c0.017-0.007,0.034-0.012,0.051-0.019l180.006-80.003	c3.611-1.604,5.938-5.186,5.938-9.138v-98.838l54.064-24.028c2.782-1.236,4.849-3.674,5.616-6.62	C506.452,289.564,505.834,286.428,504.007,283.992z M186.878,78.692c4.725-30.364,30.418-54.867,61.093-58.26 c20.25-2.247,39.677,3.929,54.703,17.381c14.826,13.272,23.329,32.289,23.329,52.173c0,21.258-9.533,41.113-26.182,54.498	c-0.628,0.509-1.264,1.008-1.914,1.492c-1.584,1.183-3.038,2.537-4.354,4.012h-27.552v-35.858l17.072-17.072 c3.905-3.905,3.905-10.237,0-14.143c-3.905-3.904-10.237-3.904-14.143,0L256,95.844L243.07,82.914 c-3.905-3.904-10.237-3.904-14.143,0c-3.905,3.905-3.905,10.237,0,14.143l17.072,17.072v35.858h-27.567 c-1.328-1.49-2.796-2.857-4.399-4.057c-0.635-0.472-1.252-0.962-1.878-1.467C192.391,128.569,182.941,103.982,186.878,78.692z M235.999,189.989c-1.522,0-2.981-0.33-4.332-0.979c-3.496-1.684-5.668-5.14-5.668-9.021v-10h60.002v10 c0,4.03-2.4,7.648-6.116,9.22c-1.224,0.518-2.531,0.78-3.884,0.78H235.999z M276,209.989c0,11.028-8.972,20.001-20.001,20.001 c-5.338,0-10.359-2.082-14.139-5.861c-3.779-3.779-5.861-8.801-5.861-14.139H276z M204.081,164.004 c0.328,0.446,0.631,0.911,0.883,1.416c0.686,1.373,1.034,2.853,1.034,4.398v10.17c0,8.6,3.758,16.724,10,22.345v7.656 c0,10.681,4.162,20.726,11.719,28.282c7.558,7.557,17.602,11.719,28.282,11.719c22.057,0,40.001-17.945,40.001-40.001v-7.652 c6.252-5.589,10-13.641,10-22.349v-10.17c0-1.531,0.353-3.05,1.027-4.404c0.247-0.498,0.552-0.965,0.883-1.413l103.471,45.988 L256,279.048l-155.383-69.059L204.081,164.004z M31.524,285.953l47.69-63.589l161.255,71.669l-47.69,63.588L31.524,285.953z M426.005,415.497L266,486.61v-96.615c0-5.522-4.477-10-10-10c-5.523,0-10,4.478-10,10v96.615L85.994,415.497v-83.45 l105.942,47.086c4.259,1.895,9.264,0.593,12.061-3.138L256,306.659l52.002,69.335c1.937,2.582,4.931,4.001,8.004,4.001 c1.365,0,2.747-0.28,4.057-0.863l105.942-47.085V415.497z M319.222,357.62l-47.69-63.588l161.255-71.669l47.69,63.588 L319.222,357.62z'/></g></g><g><g><path d='M143.038,41.297l-42.981-19.102c-5.047-2.24-10.957,0.031-13.199,5.077c-2.244,5.046,0.029,10.956,5.076,13.2 l42.981,19.102c1.32,0.586,2.699,0.864,4.056,0.864c3.831,0,7.487-2.215,9.144-5.941C150.358,49.45,148.085,43.54,143.038,41.297z'/></g></g><g><g><path d='M425.144,27.271c-2.243-5.047-8.153-7.319-13.199-5.077l-42.981,19.102c-5.047,2.243-7.32,8.153-5.077,13.2 c1.655,3.727,5.311,5.941,9.143,5.941c1.357,0,2.736-0.278,4.056-0.864l42.981-19.102 C425.114,38.229,427.387,32.319,425.144,27.271z'/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>
  }
  arrowRight = ()=>{
    return  <FontAwesomeIcon icon={faArrowRight} style={this.state.style}/>
  }
  arrowLeft = ()=>{
    return  <FontAwesomeIcon icon={faArrowLeft} style={this.state.style}/>
  }
  spinner = ()=>{
    return  <FontAwesomeIcon icon={faSpinner} style={this.state.style}/>
  }
  undo = () => {
    return  <FontAwesomeIcon icon={faUndo} style={this.state.style}/>
  }
  check = () => {
    return  <FontAwesomeIcon icon={faCheck} style={this.state.style} />
  }
  checkCircle = () => {
    return  <FontAwesomeIcon icon={faCheckCircle} style={this.state.style} />
  }
  fingerprint = () => {
    return  <FontAwesomeIcon icon={faFingerprint} style={this.state.style}/>
  }
  star = () => {
    return  <FontAwesomeIcon icon={faStar} style={this.state.style}/>
  }
  clone = () => {
    return  <FontAwesomeIcon icon={faClone} style={this.state.style}/>
  }
  times = () => {
    return  <FontAwesomeIcon icon={faTimes} style={this.state.style}/>
  }
  download = () => {
    return  <FontAwesomeIcon icon={faDownload} style={this.state.style}/>
  }
  thumbsUp = () => {
    return  <FontAwesomeIcon icon={faThumbsUp} style={this.state.style}/>
  }
  euroSign = () => {
    return  <FontAwesomeIcon icon={faEuroSign} style={this.state.style}/>
  }
  globe = () => {
    return  <FontAwesomeIcon icon={faGlobe} style={this.state.style}/>
  }
  home = () => {
    return  <FontAwesomeIcon icon={faHome} style={this.state.style}/>
  }
  bolt = () => {
    return  <FontAwesomeIcon icon={faBolt} style={this.state.style}/>
  }
  lock = () => {
    return  <FontAwesomeIcon icon={faLock} style={this.state.style}/>
  }
  tv = () => {
    return  <FontAwesomeIcon icon={faTv} style={this.state.style}/>
  }
  toggleOn = () => {
    return  <FontAwesomeIcon icon={faToggleOn} style={this.state.style}/>
  }
  thermometerHalf = () => {
    return  <FontAwesomeIcon icon={faThermometerHalf} style={this.state.style}/>
  }
  microchip = () => {
    return  <FontAwesomeIcon icon={faMicrochip} style={this.state.style}/>
  }
  chevronUp = () => {
    return  <FontAwesomeIcon icon={faChevronUp} style={this.state.style}/>
  }
  chevronRight = () => {
    return  <FontAwesomeIcon icon={faChevronRight} style={this.state.style}/>
  }
  amazon = () => {
    return  <FontAwesomeIcon icon={faAmazon} style={this.state.style}/>
  }
  info = () => {
    return  <FontAwesomeIcon icon={faInfo} style={this.state.style}/>
  }
  lightbulb = () => {
    return  <FontAwesomeIcon icon={faLightbulb} style={this.state.style}/>
  }
  lightbulbR = () => {
    return  <FontAwesomeIcon icon={faLightbulbR} style={this.state.style}/>
  }
  cog = () => {
    return  <FontAwesomeIcon icon={faCog} style={this.state.style}/>
  }
  forward = () => {
    return <FontAwesomeIcon icon={faForward} style={this.state.style}/>
  }
  squareR = () => {
    return <FontAwesomeIcon icon={faSquareR} style={this.state.style}/>
  }
  checkSquareR= () => {
    return <FontAwesomeIcon icon={faCheckSquareR} style={this.state.style}/>
  }
  shoppingCart = ()=>{
    return <FontAwesomeIcon icon={faShoppingCart} style={this.state.style}/>
  }
  cloud = ()=>{
    return <FontAwesomeIcon icon={faCloud} style={this.state.style}/>
  }
  componentDidMount(){
    var style = this.props.style;
    if(!style){
      style = {};
    }
    if(!style.hasOwnProperty('width')){
      style.width = this.props.width;
    }
    if(!style.hasOwnProperty('height')){
      style.height = this.props.height;
    }
    this.setState({style:style});
  }
  componentDidUpdate(prevProps){
    var style = this.props.style;
    if(prevProps.style!==style){
      if(!style){
        style = {};
      }
      if(!style.hasOwnProperty('width')){
        style.width = this.props.width;
      }
      if(!style.hasOwnProperty('height')){
        style.height = this.props.height;
      }
      this.setState({style:style});
    }
  }
  render(){
    let icon =this.loader();
    switch(this.props.name){
      case 'loader':{
        icon= this.loader();
        break;
      }
      case 'package':{
        icon= this.package();
        break;
      }
      case 'arrow-right':{
        icon = this.arrowRight();
        break;
      }
      case 'arrow-left':{
        icon = this.arrowLeft();
        break;
      }
      case 'spinner':{
        icon = this.spinner();
        break;
      }
      case 'undo':{
        icon = this.undo();
        break;
      }
      case 'check':{
        icon = this.check();
        break;
      }
      case 'check-circle':{
        icon = this.checkCircle();
        break;
      }
      case 'fingerprint':{
        icon = this.fingerprint();
        break;
      }
      case 'star':{
        icon = this.star();
        break;
      }
      case 'clone':{
        icon = this.clone();
        break;
      }
      case 'times':{
        icon = this.times();
        break;
      }
      case 'download': {
        icon = this.download();
        break;
      }
      case 'thumbs-up': {
        icon = this.thumbsUp();
        break;
      }
      case 'euro-sign': {
        icon = this.euroSign();
        break;
      }
      case 'globe' : {
        icon = this.globe();
        break;
      }
      case 'home' : {
        icon = this.home();
        break;
      }
      case 'bolt' : {
        icon = this.bolt();
        break;
      }
      case 'thermometer-half' : {
        icon = this.thermometerHalf();
        break;
      }
      case 'lock' : {
        icon = this.lock();
        break;
      }
      case 'tv' : {
        icon = this.tv();
        break;
      }
      case 'toggle-on' : {
        icon = this.toggleOn();
        break;
      }
      case 'microchip' : {
        icon = this.microchip();
        break;
      }
      case 'chevron-up' : {
        icon = this.chevronUp();
        break;
      }
      case 'chevron-right' : {
        icon = this.chevronRight();
        break;
      }
      case 'amazon' : {
        icon = this.amazon();
        break;
      }
      case 'info': {
        icon = this.info();
        break;
      }
      case 'lightbulb': {
        icon = this.lightbulb();
        break;
      }
      case 'lightbulb-r': {
        icon = this.lightbulbR();
        break;
      }
      case 'cog': {
        icon = this.cog();
        break;
      }
      case 'forward': {
        icon = this.forward();
        break;
      }
      case 'square-r': {
        icon = this.squareR();
        break;
      }
      case 'check-square-r': {
        icon = this.checkSquareR();
        break;
      }
      case 'shopping-cart': {
        icon = this.shoppingCart();
        break;
      }
      case 'cloud': {
        icon = this.cloud();
        break;
      }
      default:{
        icon= '';
      }
    }
    return <div
        className={classNames('Icon',this.props.animation,{gradient:this.props.gradient})}
        style={{width:this.props.width,height:this.props.height}}
        onClick={this.props.onClick}
      >
        {this.linearGradient()}
        {icon}
    </div>;
  }
}
export default Icon;
